export default __webpack_public_path__ + "static/media/img222.99220953.png";